<template>
  <!-- 底部 -->
  <el-footer class="footerHtml">
    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="margin-right: 15px; cursor: pointer; color: inherit; text-decoration: none;">备案号:京ICP备2023005642号-1</a>
    <span>北京首钢物资贸易有限公司</span>
    <span>Copyright © 首钢集采平台 版权所有</span>
  </el-footer>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.footerHtml{
    width: 100%;
    height: 36px;
    background: #002365;
    color: #fff;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
    font-size: 12px;
  }
</style>